class CollectionFilters {
  constructor(form) {
    this.form = form;
    this.init();
  }
  
  init() {
    if (this.form) {
      this.form.addEventListener('change', () => {
        this.updateFilters();
      });
    }
  }
  
  updateFilters() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData);
    const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
    
    window.location.href = newUrl;
  }
}

class CollectionSort {
  constructor(select) {
    this.select = select;
    this.init();
  }
  
  init() {
    if (this.select) {
      this.select.addEventListener('change', () => {
        this.updateSort();
      });
    }
  }
  
  updateSort() {
    const url = new URL(window.location);
    url.searchParams.set('sort_by', this.select.value);
    window.location.href = url.toString();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const filterForm = document.getElementById('FacetFiltersForm');
  if (filterForm) {
    new CollectionFilters(filterForm);
  }
  
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    new CollectionSort(sortSelect);
  }
});